import { z } from "zod/v4"
import { SystemNotificationId, SystemNotificationIdSchema } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { FirestoreTimestampSchema } from "./system"

export const SystemNotificationReadStatusDocumentMeta = z.object({
  system_notification_id: SystemNotificationIdSchema.describe("対象のお知らせID"),
  read_at: FirestoreTimestampSchema.nullable().describe("既読日時（serverTimestamp書き込み、nullなら未読）"),
  has_seen_launch_popup: z.boolean().describe("起動時ポップアップを表示済みかどうか"),
})

export type SystemNotificationReadStatusDocumentMeta = z.infer<typeof SystemNotificationReadStatusDocumentMeta>

export const SystemNotificationReadStatusDocumentBody = SystemNotificationReadStatusDocumentMeta

export type SystemNotificationReadStatusDocumentBody = z.infer<typeof SystemNotificationReadStatusDocumentBody>

export type SystemNotificationReadStatusDocument = SystemNotificationReadStatusDocumentBody & {
  id: SystemNotificationId,
}

export class SystemNotificationReadStatusDocuments {

  static toDocumentData(status: SystemNotificationReadStatusDocumentBody): object {
    return {
      ...status,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): SystemNotificationReadStatusDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: SystemNotificationId(doc.id),
      system_notification_id: data["system_notification_id"],
      read_at: data["read_at"],
      has_seen_launch_popup: data["has_seen_launch_popup"],
    }
  }
}